export default class Class {
  constructor(id, day, dayAbbrev, description, period, time, title) {
    this.id = id != null ? id : "";
    this.day = day != null ? day : "";
    this.dayAbbrev = dayAbbrev != null ? dayAbbrev : "";
    this.description = description != null ? description : "";
    this.period = period != null ? period : "";
    this.time = time != null ? time : "";
    this.title = title != null ? title : "";
  }
}